import { useTranslation } from "react-i18next";
import { Input, Select } from "@tellescope/design-system";
import type { HideUnsubmittedAfter } from "../../../../../../shared/schema";
import { useHideAfterInput } from "./useHideAfterInput";

interface HideAfterInputProps {
  value: HideUnsubmittedAfter;
  onChange: (value: HideUnsubmittedAfter) => void;
}

export const HideAfterInput = ({ value, onChange }: HideAfterInputProps) => {
  const { t } = useTranslation();
  const { amountInputValue, handleAmountChange, handleAmountBlur, handleUnitChange } = useHideAfterInput(
    value,
    onChange
  );

  return (
    <div className="flex items-center gap-2">
      <Input
        aria-label={t("Amount")}
        type="number"
        min={1}
        step={1}
        value={amountInputValue}
        onChange={(e) => handleAmountChange(e.target.value)}
        onBlur={handleAmountBlur}
        className="w-20 shrink-0"
      />
      <Select value={value.unit} onValueChange={handleUnitChange}>
        <Select.Trigger className="w-28 shrink-0" aria-label={t("Unit")}>
          <Select.Value />
        </Select.Trigger>
        <Select.Content>
          <Select.Item value="minutes">{t("Minutes")}</Select.Item>
          <Select.Item value="hours">{t("Hours")}</Select.Item>
          <Select.Item value="days">{t("Days")}</Select.Item>
          <Select.Item value="weeks">{t("Weeks")}</Select.Item>
        </Select.Content>
      </Select>
    </div>
  );
};
